import React from 'react';
import UserScoreCard from 'components/blocks/userScoreCard';
import { IKeyedUserScore } from 'store/reducers/users/types';
import './ScoreHistory.scss';

function ScoreHistory({
    userScores,
}: {
    userScores: IKeyedUserScore[];
}): React.ReactElement {
    return (
        <div className="score-history">
            {userScores.map(userScore => {
                return (
                    <UserScoreCard
                        key={userScore.id}
                        comment={userScore.comment}
                        count={userScore.count}
                        date={userScore.date}
                    />
                );
            })}
        </div>
    );
}

export default React.memo(ScoreHistory);
